// utils
import * as methods from '@utils/methods';

import { DELETE, GET, POST, PUT } from '../request';

/**
 * fetch elbows list
 * @param {*} payload
 */
export async function fetchElbowsList(payload) {
  const params = methods.convertQueryString(payload);
  return GET(`elbows?${params}`);
}

/**
 * get elbows
 * @param {*} payload
 */

export async function fetchElbows(payload) {
  return GET(`elbows/${payload}`);
}

/**
 * update elbows by id
 * @param {*} payload
 */
export async function updateElbowsById(payload) {
  const { id, ...rest } = payload;
  return PUT(`elbows/${id}`, rest);
}

/**
 * remove elbows by id
 * @param {*} payload
 */
export async function removeElbowsById(payload) {
  return DELETE(`elbows/${payload}`);
}

/**
 * create elbows
 * @param {*} payload
 */
export async function createElbows(payload) {
  return POST(`elbows`, payload);
}
